<div class="min-h-screen bg-[#F3F4F6] dark:bg-slate-900 text-sm p-4 md:p-8 text-slate-600 dark:text-slate-300">
  <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">Stamp Members</h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
        สมาชิกกลุ่มแสตมป์ (อ่านอย่างเดียว)
      </p>
    </div>
    <div class="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full sm:w-auto">
      <div *ngIf="lastFetchedTime" class="flex flex-col items-end text-right">
        <span class="text-[11px] text-slate-400 dark:text-slate-500 font-medium leading-none mb-1">ดึงข้อมูลล่าสุด</span>
        <span class="text-[13px] font-bold text-slate-600 dark:text-slate-400 leading-none">{{ lastFetchedTime | date:'HH:mm:ss' }}</span>
      </div>
      <button type="button" (click)="onRefresh()"
        class="p-3 bg-white dark:bg-slate-800 text-slate-500 dark:text-slate-400 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 hover:text-amber-500 dark:hover:text-amber-400 hover:shadow-md transition-all active:scale-95 flex items-center justify-center h-[46px]"
        title="รีเฟรชข้อมูล">
        <span class="material-icons">refresh</span>
      </button>
    </div>
  </div>

  <div class="animate-fade-in bg-white dark:bg-slate-800 rounded-3xl shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-slate-100 dark:border-slate-700 overflow-hidden relative"
    style="animation-delay: 0.1s;">
    <div class="p-6 border-b border-slate-100 dark:border-slate-700 flex flex-col lg:flex-row lg:items-center justify-between gap-4">
      <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
        <span class="material-icons text-amber-500">badge</span>
        รายชื่อสมาชิก
        <span *ngIf="siteState.selectedSite()?.name"
          class="text-xs font-semibold text-amber-600 dark:text-amber-400 bg-amber-50 dark:bg-amber-900/30 px-2 py-1 rounded-lg">
          {{ siteState.selectedSite()?.name }}
        </span>
      </h3>
      <div class="relative w-full sm:w-80">
        <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[20px] pointer-events-none">search</span>
        <input type="text" [ngModel]="searchText()" (ngModelChange)="searchText.set($event); onSearchChange()"
          placeholder="ค้นหา login / group..."
          class="w-full pl-10 pr-4 bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 text-sm rounded-xl font-medium outline-none focus:ring-2 focus:ring-amber-200 dark:focus:ring-amber-500/30 h-[46px] text-slate-700 dark:text-slate-200 placeholder:text-slate-400">
      </div>
    </div>

    <div class="overflow-x-auto h-[520px] relative custom-scrollbar" [class.opacity-50]="isLoading()">
      <table class="w-full text-left border-collapse">
        <thead class="sticky top-0 z-20 bg-white/95 dark:bg-slate-800/95 backdrop-blur-sm shadow-sm">
          <tr class="text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider">
            <th class="p-5">Login</th>
            <th class="p-5">Group</th>
            <th class="p-5">Cost</th>
            <th class="p-5">Rates</th>
            <th class="p-5 text-center">Used</th>
            <th class="p-5 text-center">Month</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-slate-50 dark:divide-slate-700">
          <tr *ngFor="let item of items(); trackBy: trackById"
            class="animate-table-row group hover:bg-amber-50/40 dark:hover:bg-slate-700/50 transition-colors duration-200">
            <td class="p-5 font-semibold text-slate-700 dark:text-slate-200">{{ item.login || '—' }}</td>
            <td class="p-5">
              <div class="flex flex-col gap-0.5">
                <span class="font-medium text-slate-700 dark:text-slate-200">{{ item.groupName || '—' }}</span>
                <span *ngIf="item.groupActive !== undefined"
                  class="inline-flex w-fit px-2 py-0.5 rounded-full text-[10px] font-bold border"
                  [ngClass]="item.groupActive
                    ? 'bg-green-50 dark:bg-green-900/30 text-green-700 dark:text-green-400 border-green-200 dark:border-green-800'
                    : 'bg-slate-50 dark:bg-slate-800 text-slate-500 dark:text-slate-400 border-slate-200 dark:border-slate-700'">
                  {{ item.groupActive ? 'Active' : 'Inactive' }}
                </span>
              </div>
            </td>
            <td class="p-5">
              <span class="inline-flex px-2.5 py-1 rounded-full text-xs font-bold bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 border border-blue-200 dark:border-blue-800">
                {{ item.costType || '—' }}
              </span>
            </td>
            <td class="p-5 text-sm text-slate-600 dark:text-slate-300 max-w-[220px] truncate" [title]="item.discountRates">
              {{ item.discountRates || '—' }}
            </td>
            <td class="p-5 text-center font-bold text-slate-700 dark:text-slate-200">{{ item.usedQty | number }}</td>
            <td class="p-5 text-center font-bold text-slate-700 dark:text-slate-200">{{ item.usedMonthQty | number }}</td>
          </tr>
          <tr *ngIf="!selectedSiteId && !isLoading()">
            <td colspan="6" class="py-20 text-center">
              <div class="flex flex-col items-center justify-center text-slate-400">
                <span class="material-icons text-4xl mb-2">location_city</span>
                <p class="font-bold text-slate-700 dark:text-slate-200">กรุณาเลือกลานจาก Sidebar</p>
              </div>
            </td>
          </tr>
          <tr *ngIf="selectedSiteId && !isLoading() && items().length === 0">
            <td colspan="6" class="py-20 text-center">
              <div class="flex flex-col items-center justify-center text-slate-400">
                <span class="material-icons text-4xl mb-2">search_off</span>
                <p class="font-bold text-slate-700 dark:text-slate-200">ไม่พบข้อมูล</p>
                <span class="text-sm mt-1">ลองค้นหาด้วย login หรือชื่อกลุ่ม</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="px-6 py-4 border-t border-slate-100 dark:border-slate-700 flex flex-col md:flex-row items-center justify-between gap-4">
      <div class="text-sm text-slate-500 dark:text-slate-400 font-medium">
        แสดง {{ startItemIndex | number }} - {{ endItemIndex | number }} จาก {{ totalItems() | number }} รายการ
      </div>
      <div class="flex items-center gap-2">
        <button type="button" (click)="setPage(currentPage() - 1)" [disabled]="currentPage() === 1"
          class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:text-amber-500 disabled:opacity-30 transition-all">
          <span class="material-icons text-sm">chevron_left</span>
        </button>
        <button *ngFor="let p of pagesArray" type="button" (click)="setPage(p)"
          class="w-9 h-9 flex items-center justify-center rounded-lg text-sm font-bold transition-all"
          [ngClass]="p === currentPage()
            ? 'bg-amber-400 dark:bg-amber-500 text-white shadow-lg shadow-amber-200 dark:shadow-none'
            : 'text-slate-600 dark:text-slate-300 hover:bg-amber-50 dark:hover:bg-slate-700'">
          {{ p }}
        </button>
        <button type="button" (click)="setPage(currentPage() + 1)"
          [disabled]="currentPage() === totalPages() || totalPages() === 0"
          class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:text-amber-500 disabled:opacity-30 transition-all">
          <span class="material-icons text-sm">chevron_right</span>
        </button>
      </div>
    </div>
  </div>
</div>

<app-pss-loading *ngIf="isLoading()"></app-pss-loading>
